<div *ngIf="orders" class="basket-main order-info-main">
  <div class="basket-main-header order-info-header">
    <div class="row">
      <div class="col-2 d-none d-md-block text-left">
        {{ 'Date' | translate }}
      </div>
      <div class="col-3 col-md order_number">
        {{ 'Order number' | translate }}
      </div>
      <div class="col-2 d-none d-md-block text-right">
        {{ 'Amount' | translate }}
      </div>
      <div class="col-5 d-none d-md-block text-center">
      </div>
    </div>
  </div>
  <div *ngFor="let order of orders" class="basket-main-content order-info-content">
    <div class="row" [ngClass]="{isCancelOrder: order.state == 'cancel'}">
      <div class="col-3 col-md-2 text-left">
        {{ formatDate(order.date) }}
      </div>
      <div class="col-5 col-md-3 order_number">
        <a (click)="onOrderClick(order)">
          {{ order.name | translate }}
        </a>
      </div>
      <div class="col-4 col-md-2 text-right">
        {{ toMoneyStr(order.amount) }}
      </div>
      <div *ngIf="order.state != 'cancel'" class="col-12 col-md-5 text-left text-md-right">
        <div class="row order-buttons justify-content-md-end justify-content-around">
          <a (click)="onOrderClick(order)">
            <fa-icon [icon]="faSearch" class="orderIcon  d-md-block">
            </fa-icon>
          </a>
          <a *ngIf="order.state!=='draft'" [attr.href]="order.url" target="_blank">
            <span class="d-md-block">
              <div class="swg-icon pdf-file-icon" [inlineSVG]="'assets/svg/icon/pdf-file.svg'"></div>
            </span>
          </a>
          <a *ngIf="order.state!=='draft' && order.ticketUrl" [attr.href]="order.ticketPDFUrl" target="_blank">
            <span class="d-md-block">
              <fa-icon class="orderIcon" [icon]="faTicketAlt"></fa-icon>
            </span>
          </a>
          <a *ngIf="order.state!=='draft' && order.giftcardUrl && !order.isCreditCard" [attr.href]="order.giftcardPDFUrl" target="_blank">
            <span class="d-md-block">
              <fa-icon class="orderIcon" [icon]="faGift"></fa-icon>
            </span>
          </a>
          <a *ngIf="order.state=='draft'" (click)="onPaymentClick(order)">
            <span class="d-md-block">{{ "PayOrderDetails" | translate }}</span>
          </a>
          <a *ngIf="order.state=='draft'" (click)="onCancelClick(order)">
            <span class="d-md-block">{{ "CancelOrderDetails" | translate }}</span>
          </a>
        </div>
      </div>
    </div>
  </div>
</div>
